import { CONSTANTS } from "src/app/config/constants";
import { TypeOf } from "src/app/enum/type-of";

export class StringHelper {
	public static sprintf(format: string, ...args: any[]) {
		let i = 0;
		return format.replace(/%s|%d/g, () => args[i++]);
	}

	public static padLeft(value: any, quantity = 2, str = '0') {
		value = Math.round(value);
		return Array(quantity - String(value).length + 1).join(str) + value;
	}

	public static phone(value: string, code: string | null = null) {
		if (!value) {
			return value;
		}
		value = value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
		if (code) {
			value = StringHelper.sprintf('+%d %s', code, value);
		}
		return value;
	}

	public static onlyNumbers(value: string, code: string | null = null) {
		if (!value) {
			return value;
		}
		value = value.replace(/\D/g, '');
		return value;
	}

  public static isEmpty(str) {
    return (!str || str.length === 0 );
}

	public static error(data: any): string {
		if (!data) {
			return "";
		}
		const messages: Array<string> = [];
		if (data && typeof data === TypeOf.STRING) {
			messages.push(data);
		}
		if (data && typeof data.error === TypeOf.STRING) {
			messages.push(data.error);
		}
		if (data && data.name && data.name.toLowerCase() === 'timeouterror') {
			messages.push('The request got time out.');
			messages.push('Check your internet connection.');
		}
		if (
			data &&
			data.status &&
			data.status === 0 &&
			data.name &&
			data.name.toLowerCase() === 'httperrorresponse'
		) {
			messages.push('The request got an error.');
			messages.push('Check your internet connection.');
		}
		if (data && data.error && data.error.message) {
			messages.push(data.error.message);
		}
		if (data && data.error && data.error.errors) {
			Object.keys(data.error.errors).forEach((errorKey) =>
				data.error.errors[errorKey].forEach((key: any) => messages.push(key))
			);
		}
		if (!messages || !messages.length) {
			messages.push('Sorry, something went wrong!');
		}
		return messages.join('\n');
	}

	public static toBoolean(value: string): boolean {
		return (
			value?.trim().toLowerCase() === 'true' ||
			value?.trim().toLowerCase() === '1' ||
			value?.trim().toLowerCase() === 'yes'
		);
	}

	public static urlParameter(url: string, name: string): string {
		if (!url) {
			url = window.location.href;
		}
		name = name.replace(/[\[\]]/g, '\\$&');
		const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
		const results = regex.exec(url);
		if (!results) {
			return "";
		}
		if (!results[2]) {
			return '';
		}
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
}
